module.exports = __webpack_public_path__ + "ca0818fce6aba9eafbd03cf1b3a6f4f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/oval.png
// module id = 769
// module chunks = 0